import React from 'react';
import Routes from './components/Routes';
import { ConfirmDialogProvider } from './components/common/ConfirmDialogProvider';
import { ToastProvider } from './components/common/ToastProvider';
import { initializeIcons } from '@uifabric/icons';
import {
  loadTheme,
  registerIcons,
  registerIconAlias,
} from 'office-ui-fabric-react';
import 'office-ui-fabric-react/dist/css/fabric.min.css';
// import './topCss.css';
import { THEME } from './utils/Styles';
// import Icon from "@mdi/react";
// import { mdiHomeOutline, mdiServerNetwork, mdiAccountGroupOutline, mdiAccountMultiple, mdiAccountMultipleOutline } from "@mdi/js";
import { ICONS } from './utils/Icons';
import ErrorBoundary from './components/common/ErrorBounday';
import { PasswordChangeAlertProvider } from './components/change-password/PasswordChangeAlertProvider';
// import {Icons} from "./utils/icons";
initializeIcons();
loadTheme(THEME);
registerIcons({
  icons: ICONS,
});
registerIconAlias('Search', 'SearchMdn');
registerIconAlias('ChevronDown', 'ChevronDownMdn');
registerIconAlias('ChromeClose', 'ChromeCloseMdn');
registerIconAlias('ChevronRightMed', 'ChevronRightMedMdn');
registerIconAlias('More', 'MoreMdn');

const App: React.FC = () => {
  return (
    <div>
      <ErrorBoundary>
        <ConfirmDialogProvider>
          <PasswordChangeAlertProvider>
            <ToastProvider>
              <Routes />
            </ToastProvider>
          </PasswordChangeAlertProvider>
        </ConfirmDialogProvider>
      </ErrorBoundary>
    </div>
  );
};

export default App;
